import React from 'react';

import InfoIcon from '@mui/icons-material/Info';
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Divider,
  Box,
  Link,
} from '@mui/material';

import ChangelogDialog from '@/components/ChangelogDialog';
import LegalDialog from '@/components/LegalDialog';
import LicenseDialog from '@/components/LicenseDialog';
import { version } from '@/constants/env';

const AboutItem: React.FC = () => {
  const [open, setOpen] = React.useState(false);
  const [openHistory, setOpenHistory] = React.useState(false);
  const [openLicense, setOpenLicense] = React.useState(false);
  const [openLegal, setOpenLegal] = React.useState(false);

  return (
    <>
      <ListItem
        id="account-about"
        button
        onClick={() => setOpen(true)}
      >
        <ListItemIcon>
          <InfoIcon />
        </ListItemIcon>
        <ListItemText primary="アプリ情報" />
      </ListItem>
      {open && (
        <Dialog
          open
          fullWidth
          maxWidth="sm"
          onClose={() => setOpen(false)}
        >
          <DialogTitle sx={{ textAlign: 'center' }}>
            Wagakoアプリについて
          </DialogTitle>
          <DialogContent>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              <Typography variant="h6">アプリ情報</Typography>
              <Typography variant="body2">名称: Wagako App (保護者向け)</Typography>
              <Typography variant="body2">
                バージョン情報:
                <Button
                  id="account-about-version"
                  variant="text"
                  size="small"
                  onClick={() => setOpenHistory(true)}
                  sx={{
                    p: 0, minWidth: 0, textTransform: 'none', ml: 0.5,
                  }}
                >
                  {version}
                </Button>
              </Typography>
              <Divider sx={{ my: 1.5 }} />
              <Typography variant="h6">提供・サポート</Typography>
              <Typography variant="body2">提供: 株式会社ZIDO</Typography>
              <Typography variant="body2">
                お問い合わせ:
                {' '}
                <Link href="https://zido.co.jp/contact.html" target="_blank" rel="noreferrer">https://zido.co.jp/contact.html</Link>
              </Typography>
              <Divider sx={{ my: 1.5 }} />
              <Typography variant="h6">免責事項</Typography>
              <Button
                id="account-about-legal"
                variant="text"
                size="small"
                onClick={() => setOpenLegal(true)}
                sx={{
                  p: 0, minWidth: 0, textTransform: 'none', ml: 1,
                }}
              >
                免責事項を表示
              </Button>
              <Typography variant="h6" sx={{ mt: 1.5 }}>ライセンス</Typography>
              <Button
                id="account-about-license"
                variant="text"
                size="small"
                onClick={() => setOpenLicense(true)}
                sx={{
                  p: 0, minWidth: 0, textTransform: 'none', ml: 1,
                }}
              >
                ライセンス情報を表示
              </Button>
            </Box>
          </DialogContent>
          <DialogActions sx={{ justifyContent: 'center' }}>
            <Button onClick={() => setOpen(false)}>閉じる</Button>
          </DialogActions>
        </Dialog>
      )}
      <ChangelogDialog
        open={openHistory}
        version={version}
        onClose={() => setOpenHistory(false)}
      />
      <LicenseDialog
        open={openLicense}
        onClose={() => setOpenLicense(false)}
      />
      <LegalDialog
        open={openLegal}
        onClose={() => setOpenLegal(false)}
        src="/legal.html"
        title="免責事項（詳細）"
      />
    </>
  );
};

export default AboutItem;
